import '../../assets/css/aboutus.css'
import about1 from '../../assets/images/aboutus-about_img1.png'
import about2 from '../../assets/images/aboutus-about_img2.png'

export default function WhoWeAre() {
    return (
        <>
            <div className="About-us-title">
                <h2 className="wow bounceIn">Who we are</h2>
                <p className="wow bounceIn">We experience our clients business hypothesis to become shoutout their routine
                    circumstances in easy going with our expertise technical teamwork for object completion and feel relaxation in
                    management, professional and personal workout.</p>
                <span className="title-border"></span>
            </div>
            <div className="about-us-services1">
                <div className="col-md-6 float-left">
                    <div className="about-us-services1-image wow fadeInLeft">
                        <img src={about1} />
                    </div>
                </div>
                <div className="col-md-6 float-left">
                    <div className="about-us-services1-text wow fadeInRight">
                        <h2>Vision</h2>
                        <p>We at SRP Infotech firmly believe in becoming one of the most advanced service provider company.</p>
                        <p>We are focused to provide reliable, quality and the best IT services to our customers across the globe.
                        </p>
                    </div>
                </div>
            </div>

            <div className="about-us-services2">
                <div className="col-md-6 float-left">
                    <div className="about-us-services1-text wow fadeInLeft">
                        <h2>Mission</h2>
                        <p>Our mission is to provide excellent services to our customers so that they step out happily with the best
                            IT solutions.</p>
                        <p>We always want to be customer centric and achieve the best place in the industry!</p>
                    </div>
                </div>
                <div className="col-md-6 float-right">
                    <div className="about-us-services2-image wow fadeInRight">
                        <img src={about2} />
                    </div>
                </div>
            </div>
        </>
    )
}